export default __webpack_public_path__ + "e680b11b48a998d0fba74a6d415f62df.svg";